"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankstatementsTimeslotsToJSON = exports.BankstatementsTimeslotsFromJSONTyped = exports.BankstatementsTimeslotsFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function BankstatementsTimeslotsFromJSON(json) {
    return BankstatementsTimeslotsFromJSONTyped(json, false);
}
exports.BankstatementsTimeslotsFromJSON = BankstatementsTimeslotsFromJSON;
function BankstatementsTimeslotsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'value': !(0, runtime_1.exists)(json, 'value') ? undefined : json['value'],
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'balances': !(0, runtime_1.exists)(json, 'balances') ? undefined : (0, _1.BankstatementsBalancesFromJSON)(json['balances']),
    };
}
exports.BankstatementsTimeslotsFromJSONTyped = BankstatementsTimeslotsFromJSONTyped;
function BankstatementsTimeslotsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'value': value.value,
        'id': value.id,
        'balances': (0, _1.BankstatementsBalancesToJSON)(value.balances),
    };
}
exports.BankstatementsTimeslotsToJSON = BankstatementsTimeslotsToJSON;
//# sourceMappingURL=BankstatementsTimeslots.js.map